import {
    LOGIN_SUCCESS,
    LOGIN_ERROR,
    SUBMIT_LOGIN,
    LOGOUT
} from '../actionTypes'

import { request } from '../../utils/api'

export const login = form => async dispatch => {
    form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
            try {
                dispatch(submitLogin())
                const { code, id, tipo, nivelVerificacao, token, nome, permissao, message, cpf } = await request('users/login', 'POST', {
                    username: values.email,
                    password: values.password
                })
                if (code === 200 && id) {
                    if(nivelVerificacao === '000') {
                        dispatch(loginError('Por favor, verifique seu e-mail para continuar.'))
                    } else {
                        dispatch(loginSuccess(id, tipo, token, nivelVerificacao, nome))
                        if(cpf === null) {
                            window.location.replace('/finalizar-cadastro')
                        } else {
                            window.location.replace('/meusinvestimentos')
                        }
                    }
                } else {
                    dispatch(loginError(message))
                }
            } catch(e) {
                console.log(e)
                dispatch(loginError())
            }
        }
    })
}

export const loginSuccess = (id, tipo, token, nivelVerificacao, nome) => ({
    type: LOGIN_SUCCESS,
    payload: {
        id,
        tipo,
        token,
        nivelVerificacao, 
        nome
    }
})

export const loginError = (message = 'Ops! Algo deu errado!') => ({
    type: LOGIN_ERROR,
    payload: {
        message
    }
})

export const submitLogin = () => ({
    type: SUBMIT_LOGIN
})

export const logout = () => ({
    type: LOGOUT
})